'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormControlComponent = require('./FormControlComponent');

var _FormControlComponent2 = _interopRequireDefault(_FormControlComponent);

var _currencyHelper = require('../../helpers/currencyHelper');

var _currencyHelper2 = _interopRequireDefault(_currencyHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a text input field.
 * @extends {Component}
 */
var CurrencyInputComponent = function (_React$Component) {
  _inherits(CurrencyInputComponent, _React$Component);

  function CurrencyInputComponent() {
    _classCallCheck(this, CurrencyInputComponent);

    return _possibleConstructorReturn(this, (CurrencyInputComponent.__proto__ || Object.getPrototypeOf(CurrencyInputComponent)).apply(this, arguments));
  }

  _createClass(CurrencyInputComponent, [{
    key: 'render',
    value: function render() {
      this.props.field.value = (0, _currencyHelper2.default)(this.props.field.value, this.props.prefix, this.props.precision, this.props.thousandSeparator, this.props.decimalSeparator);
      return _react2.default.createElement(_FormControlComponent2.default, _extends({}, this.props, {
        field: this.props.field,
        formControlType: this.props.type,
        className: 'ingle-form-text-input',
        placeholder: this.props.htmlPlaceholder
      }));
    }
  }]);

  return CurrencyInputComponent;
}(_react2.default.Component);

CurrencyInputComponent.propTypes = {
  field: _react2.default.PropTypes.object.isRequired,
  htmlPlaceholder: _react2.default.PropTypes.string,
  type: _react2.default.PropTypes.string,
  prefix: _react2.default.PropTypes.string,
  precision: _react2.default.PropTypes.number,
  thousandSeparator: _react2.default.PropTypes.string,
  decimalSeparator: _react2.default.PropTypes.string
};
CurrencyInputComponent.defaultProps = {
  type: 'text',
  prefix: '$',
  precision: 2,
  thousandSeparator: ',',
  decimalSeparator: '.'
};
exports.default = CurrencyInputComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/CurrencyInputComponent.jsx
// module id = 178
// module chunks = 0